import { useMemo } from 'react';
import { useCampaignSettingsSelector } from './useCampaignSettingsSelector';

export const useAllowListSelector = () => {
  const settings = useCampaignSettingsSelector();
  return useMemo(() => settings.allowList, [settings.allowList]);
};
